/**
 * Expands to fill space between sibling components.
 *
 * Notes:
 * - This must be used inside a flexbox layout.
 * - Be careful when using this component around animated elements.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

/**
 * @deprecated Please use Spring from @khanacademy/wonder-blocks-layout instead.
 */
class DeprecatedSpring extends React.Component<Empty> {
    render(): React.ReactNode {
        return <div className={css(styles.grow)} />;
    }
}

const styles = StyleSheet.create({
    grow: {
        flexGrow: 1,
    },
});

export default DeprecatedSpring;
